export const FETCH_NOTICE_LIST = 'FETCH_NOTICE_LIST';
export const SET_CURRENT_NOTICE = 'SET_CURRENT_NOTICE';
